<pbc-filter [config]="ReisekostenabrechnungenFilterConfig" [filter]="reisekostenabrechnungen.filter$ | async" (filterChange)="reisekostenabrechnungen.filter$.next($event)"></pbc-filter>
